export class PaymentGateway {
  public static Adyen = { description: 'ADYEN (IS)', value: 'ADYEN' };
  public static Stripe = { description: 'STRIPE (COM)', value: 'STRIPE' };
  public static Borgun = { description: 'BORGUN (AA)', value: 'BORGUN' };
  public static BorgunYdt = { description: 'BORGUN (YDT)', value: 'BORGUNYDT' };
  public static StripeIs = { description: 'STRIPE (IS)', value: 'STRIPEIS' };
}
